

import React from 'react'

import BasicCroDetail from '../components/Basiccro-detail';
import BasiccroData from '../components/basi-crodata';
import Leadcro from '../components/Lead-cro';
import usePageMeta from '../hooks/usePageMeta';

export default function Cro() {
    usePageMeta('Conversion Rate Optimization (CRO) Agency | Spinnennetz', 'Maximize your website\'s revenue with our expert Conversion Rate Optimization services. We use data-driven strategies to turn visitors into loyal customers.', '/cro', {"@context":"https://schema.org","@type":"Service","name":"Conversion Rate Optimization (CRO)","provider":{"@type":"Organization","name":"Spinnennetz"}}, 'conversion rate optimization agency, ecommerce CRO expert, increase website conversion rate, AI-powered CRO, conversion rate optimization consultant');
    return (
        <>
            <BasicCroDetail/> 
            <BasiccroData/>
            <Leadcro/>
          
        </>
    );
}
